import React, { useContext, useEffect, useRef } from "react"
import { store as socketStore } from "./store"
import { createEventsResponseCacheHandler } from "pages/EventsManagement/eventCachePolicy"

const getListenFunction = (topic, listenFunction) =>
  topic === "events-response"
    ? createEventsResponseCacheHandler(listenFunction)
    : listenFunction

const ListenerComponent = ({ topic, listenFunction }) => {
  const globalState = useContext(socketStore)
  const {
    state: { socket: { socketClientId, socket } = {} } = {},
  } = globalState
  const listenFunctionRef = useRef(listenFunction)

  listenFunctionRef.current = listenFunction

  useEffect(() => {
    if (!socket) return undefined

    const topics = Array.isArray(topic) ? topic : [topic]
    const handlers = topics.map(currentTopic => {
      const handler = getListenFunction(currentTopic, payload =>
        listenFunctionRef.current(payload)
      )
      socket.on(currentTopic, handler)
      return { currentTopic, handler }
    })

    return () => {
      handlers.forEach(({ currentTopic, handler }) => {
        socket.off(currentTopic, handler)
      })
    }
  }, [socket, socketClientId, topic])
  return <div></div>
}

export default ListenerComponent
